
export class NewCivilParty {
  FirstName: string= "";
  LastName: string= "";
  AddressLine1: string= "";
  AddressLine2: string= "";
  City: string= "";
  State: string= "";
  Zip: string= "";
  DateOfBirth: Date;
  PhoneNumber: string= "";
  Email: string= "";
  IsBusiness: boolean = false;
  IsPlaintiff: boolean = false;

  constructor(init?: Partial<NewCivilParty>) {
    Object.assign(this, init);
  }
}